import React, { useState } from 'react';
import { NavBar } from './components/NavBar';
import { Hero } from './components/Hero';
import { WhyChooseUs } from './components/WhyChooseUs';
import { PortfolioSection } from './components/PortfolioSection';
import { PortfolioModal } from './components/PortfolioModal';
import { ShopifyAd } from './components/ShopifyAd';

// ====================== MAIN APP ======================
function App() {
  const [activeSection, setActiveSection] = useState('home');
  const [selectedFilter, setSelectedFilter] = useState('all');
  const [selectedItem, setSelectedItem] = useState(null);
  const portfolioRef = React.useRef(null);

  const goToPortfolio = (filter) => {
    setSelectedFilter(filter);
    setActiveSection('portfolio');
  };

  // Shopify storefront link used by the Hero button
  const shopifyLinks = {
    storefront: 'https://shop.campbellsflyingmachines.com',
  };

  const shopifyProductLink = 'https://shop.campbellsflyingmachines.com/products/all-you-can-get-real-estate-first-time-buyer';

  return (
    <div className="min-h-screen bg-slate-950" style={{ backgroundColor: '#0a0e1a' }}>
      <NavBar activeSection={activeSection} setActiveSection={setActiveSection} />

      <main>
        {/* HOME */}
        {activeSection === 'home' && (
          <>
            <Hero 
              setActiveSection={setActiveSection} 
              goToPortfolio={goToPortfolio}
              shopifyLinks={shopifyLinks} 
            />
            <ShopifyAd shopifyLink={shopifyProductLink} />
            <WhyChooseUs />
          </>
        )}

        {/* PORTFOLIO */}
        {activeSection === 'portfolio' && (
          <PortfolioSection 
            ref={portfolioRef}
            selectedFilter={selectedFilter} 
            setSelectedFilter={setSelectedFilter} 
            setSelectedItem={setSelectedItem} 
          />
        )}

        {/* ABOUT ME SECTION */}
        {activeSection === 'about' && (
          <section className="py-16 bg-slate-950">
            <div className="max-w-4xl mx-auto px-4">
              <div className="text-center mb-12">
                <h2 className="text-4xl font-bold text-white mb-4">About Me</h2>
                <div className="w-20 h-1 bg-sky-500 mx-auto mb-8"></div>
              </div>

              <div className="bg-slate-800 rounded-2xl p-10 border border-slate-700 max-w-3xl mx-auto">
                <div className="prose prose-invert max-w-none text-slate-300 text-lg leading-relaxed">
                  <p className="mb-6">
                    Welcome to Campbell's Flying Machines! I'm JP, a passionate drone pilot and photographer. My love of aviation started when I was young and eventually I was lucky enough to fly F-18s in the Marines.
                    I look forward to continuing to try entrepreneurship in the drone industry and providing high-quality aerial photography and mapping services to my clients.
                    I live with my family in Waxhaw, North Carolina, just south of Charlotte. When I'm not flying drones, you can find me spending time with my family, hiking, or working on home improvement projects.
                    Thank you for giving the veteran-owned Campbell's Flying Machines a look! I hope to work with you soon.
                  </p>
                </div>
              </div>
            </div>
          </section>
        )}

        {/* CONTACT */}
        {activeSection === 'contact' && (
          <section className="py-12 bg-slate-950">
            <div className="max-w-6xl mx-auto px-4 text-center">
              <h2 className="text-4xl font-bold text-white mb-6">Contact Us</h2>
              <p className="text-slate-300 mb-8 text-lg">Veteran-owned • Charlotte, NC</p>
              <div className="max-w-md mx-auto bg-slate-800 rounded-2xl p-8 border border-slate-700">
                <p className="text-2xl font-semibold text-white mb-2">Ready to book?</p>
                <p className="text-slate-400 mb-8">Book directly through our Shopify store.</p>
                <a 
                  href="https://shop.campbellsflyingmachines.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="inline-block bg-sky-500 hover:bg-sky-600 text-white font-semibold px-8 py-3 rounded-xl"
                >
                  Go to Shopify Store →
                </a>
              </div>
            </div>
          </section>
        )}
      </main>

      <footer className="bg-slate-900 py-8 border-t border-slate-700">
        <div className="max-w-6xl mx-auto px-4 text-center text-slate-400 text-sm">
          <p>Campbell's Flying Machines • Veteran Owned • Charlotte, NC</p>
          <p className="mt-3">
            <a href="mailto:campbellsmachines@outlook.com" className="hover:text-white">campbellsmachines@outlook.com</a>
            &nbsp;&nbsp;|&nbsp;&nbsp;
            <a href="tel:7042929893" className="hover:text-white">(704) 292-9893</a>
          </p>
          <p className="mt-6 text-xs">© 2026 Campbell's Flying Machines LLC • All Rights Reserved</p>
        </div>
      </footer>

      <PortfolioModal selectedItem={selectedItem} setSelectedItem={setSelectedItem} />
    </div>
  );
}

export default App;